/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Theme, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Modal from "../../../../components/Modal";
import { selectCurrentCart } from "../../../cart/storage/cart.slice";
import { CartObject } from "../../../cart/storage/cart.types";
import { StoreInfo } from "../../../stores/storage/stores.types";

import StoreSelector from "./StoreSelector";

interface Props {
  productId: number;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  testId?: string;
  scrollRef?: React.RefObject<HTMLElement>;
  selectedStore?: StoreInfo;
}
const StoreAvailabilityModal = (props: Props) => {
  const cart = useSelector(selectCurrentCart);

  return <StoreAvailabilityModalContent {...props} cart={cart} />;
};

const StoreAvailabilityModalContent = ({
  productId,
  open,
  setOpen,
  testId,
  scrollRef,
  selectedStore,
  cart,
}: { cart?: CartObject } & Props) => {
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const [value, setValue] = useState<StoreInfo | undefined>(cart?.pickupStore);

  useEffect(() => {
    setValue(selectedStore);
  }, [selectedStore]);

  return (
    <Modal
      title="Store availability"
      open={open}
      handleClose={() => {
        setOpen(false);
        setValue(undefined);
      }}
      testId={testId}
      scrollRef={scrollRef}
      maxWidth="md"
      paperProps={{
        sx: { height: isSm ? "inherit" : "844px" },
      }}
    >
      <StoreSelector productId={productId} value={value} setValue={setValue} />
    </Modal>
  );
};

export default StoreAvailabilityModal;
